import { http } from '../http';

export async function getTermsDocumentUrl() {
	const termsDocumentUrl = await http.get<{ download_url: string }>('/terms');
	if (termsDocumentUrl) {
		const documentBlob = await http.getBlob(termsDocumentUrl.download_url);
		if (documentBlob) {
			const termsDocument = new File([documentBlob], 'terms.pdf');
			return termsDocument;
		} else {
			throw new Error('Response was undefined');
		}
	} else {
		throw TypeError();
	}
}
